
export function isAndroid() {
  return !!window.navigator.userAgent.match(/Android/i);
}
export function isMobileQQ() {
  const ua = window.navigator.userAgent;
  return /(iPad|iPhone|iPod).*? (IPad)?QQ\/([\d\.]+)/.test(ua) || /\bV1_AND_SQI?_([\d\.]+)(.*? QQ\/([\d\.]+))?/.test(ua);
}
export function isIOS() {
  return !!window.navigator.userAgent.match(/iPhone|iPad|iPod/i);
}
export function isWx() {
  window.wx.miniProgram.getEnv(function (res) {
    if (res.miniprogram) {
      return true;
    } else {
      return false
    }
  });
}
export function isMiniWx() {
  const ua = navigator.userAgent.toLowerCase();
  return ua.match(/MicroMessenger/i) == 'micromessenger';
}
export function isMobileBrowser() {
  //判断是否是移动端浏览器，非移动端App内嵌，安卓系统机型较多，如此判断不一定全都一致
  return window.navigator.userAgent.indexOf('Version') < 0;
}

export function isUniApp() {
  // 判断是否在UniApp WebView环境中
  return typeof window.uni !== 'undefined' &&  window.uni.postMessage;
}


// WEBPACK FOOTER //
// ./src/utils/browser.js